import { useSelector } from 'react-redux';

import { dateFormat } from 'common/helpers/dateHelper';

const CancelledMembership = (props) => {
  const { clubMembership } = props;
  const settings = useSelector((state) => state.setting);

  return (
    <div className="c7-account__club-status">
      <div>
        <h3>{clubMembership.club.title}</h3>
        <div className="c7-account-row">
          <div>
            <strong>Status</strong>
            <br />
            Cancelled {dateFormat(clubMembership.cancelDate, settings)}
            <br />
            <br />
            <strong>Joined</strong>
            <br />
            {dateFormat(clubMembership.signupDate, settings)}
            <br />
            <br />
            <strong>Shipments</strong>
            <br />
            {renderShipments(clubMembership.currentNumberOfShipments)}
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

const renderShipments = (currentNumberOfShipments) => {
  if (currentNumberOfShipments === 0) {
    return `You received no shipments`;
  }
  if (currentNumberOfShipments === 1) {
    return 'You received 1 shipment';
  }
  return `You received ${currentNumberOfShipments} shipments`;
};

export default CancelledMembership;
